<template>
    <h3 class="tile-title">
        <i :class="`uk-icon-${icon}`"></i>
        <slot></slot>
    </h3>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true,
            default: 'info-circle'
        }
    }
}
</script>

<style lang="sass" scoped>
.tile-title
    font-family: "Roboto Slab", Tahoma, sans-serif
    color: #000
    font-size: 14px
    font-weight: 700
    white-space: nowrap
    overflow: hidden
</style>